// EmployeeHome.js
import "@fortawesome/fontawesome-svg-core/styles.css";
import { useEffect, useRef, useState } from "react";
import { motion } from "framer-motion";
import AOS from "aos";
import "aos/dist/aos.css";
import { Container, Nav, Navbar } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowTrendUp,
  faFileInvoiceDollar,
  faMoneyBillTrendUp,
  faUserTie,
} from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";

import "../../src/components/styles.css";
import "./../components/user/whyichest.css";
import FooterPage from "./ExploreMore/footer";
import Version from "../components/version";
import { Homepagenotification } from "../components/alerting-visitors/notification";
import EmployeeLogin from "./EmployeeLogin";
import WhatsAppButton from "../components/WhatsAppButton";

const EmployeeHome = () => {
  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  const [showLogin, setShowLogin] = useState(false);
  const [showSignin, setShowSignin] = useState(false);
  const [key, setKey] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => setKey((prev) => prev + 1), 3000);
    return () => clearInterval(interval);
  }, []);

  const toggleLogin = () => setShowLogin(true);
  const toggleSignin = () => setShowSignin(true);
  const handleBack = () => {
    setShowLogin(false);
    setShowSignin(false);
  };

 const line1 = "Empowering those".split(" ");
const line2 = "who support legacy building.".split(" ");
const first = "Empowering those who support legacy building.".split(" ");

  return (
    <div className="homepage_design_main">
      <Navbar expand="lg" fixed="top" bg="dark" variant="dark" className="navbar_base">
        <Container>
          <Navbar.Brand href="#" className="navbar-brand logo-image">
            {/*<img src="./logo192.webp" alt="logo" />*/}
            <img src="/img/i-chestLogo-V2.png" />
            <div className="App_this">
              <div className="tab_largescreen_view">
                {first.map((el, i) => (
                  <motion.span
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ duration: 1, delay: i / 10 }}
                    key={i + key * first.length}
                  >
                    {el} {" "}
                  </motion.span>
                ))}
              </div>
              <div className="tab_movile_view">
                {line1.map((el, i) => (
                  <motion.span
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ duration: 1, delay: i / 10 }}
                    key={i + key * line1.length}
                  >
                    {el} {" "}
                  </motion.span>
                ))}
              </div>
              <div className="tab_movile_view">
                {line2.map((el, i) => (
                  <motion.span
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ duration: 0.25, delay: i / 10 }}
                    key={i + key * line2.length}
                  >
                    {el} {" "}
                  </motion.span>
                ))}
              </div>
            </div>
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="navbar-nav" />
          <Navbar.Collapse id="navbar-nav">
            <Nav className="ms-auto">
              <Nav.Link href="/">Home</Nav.Link>
              <Nav.Link href="/contact-us">Contact Us</Nav.Link>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>

      <div style={{ marginTop: "60px", position: "fixed", zIndex: 999 }}>
        <Homepagenotification />
      </div>

      {showLogin && (
        <div className="login-popup" data-aos="fade-up">
          <div className="login-content">
            <EmployeeLogin onBack={handleBack} />
          </div>
        </div>
      )}

      {showSignin && (
        <div className="login-popup" data-aos="fade-up">

        </div>
      )}

      <div id="header" className="header">
        <div className="container">
          <div className="homepage_main">
            <div className="homepage_details">
              <div className="text-container home_page_content">
                <h2>
                  'Supporting legacy with, <br />I<span style={{ color: "rgb(255 213 0)" }}>-</span>
                  Chest Employee Portal.'
                  <span style={{ fontSize: "14px", color: "#e1ff00" }}>&copy;</span>
                </h2>
                <p>
                  "Secure employee access to assist users in managing assets, resolving tickets,
            and safeguarding their digital legacy."
                </p>
              </div>
            </div>
            <div className="homepage_image">
              <div className="image-container">
                <img className="img-fluid" src="/img/homepage_image_v2.webp" alt="alternative" />
                <div className="login_buttons">
                  {/* <button className="button btn-solid-lg" onClick={toggleSignin}>
                    <span className="button-content">Sign Up</span>
                  </button> */}
                  <button className="button btn-solid-lg" onClick={toggleLogin}>
                    <span className="button-content">Sign In</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Other sections can follow from Home.js here like Key Objectives, Why I-Chest, Footer */}
      <FooterPage />
      <WhatsAppButton />
      <Version />
    </div>
  );
};

export default EmployeeHome;
